import React from 'react'
import { Healthcare } from '../../Ankita_Components/Healthcare/Healthcare'
import Footer from '../../Ankita_Components/Footer/Footer'

const HealthCarePage = () => {
  return (
    <div>
      <Healthcare/>
      <Footer/>

    </div>
  )
}

export default HealthCarePage